import s from "./FormColumns.module.css";

export const FormColumns = ({ children, columns = 2, gap = 12 }) => (
  <div
    className={s.formColumns}
    style={{
      gridTemplateColumns: `repeat(${columns}, 1fr)`,
      gap: `${gap}px`,
    }}
  >
    {children}
  </div>
);
